import React, { useState, useEffect, useCallback } from 'react';
import { Input, Select, Typography, Button, Modal, QRCode, message, Checkbox, Switch } from 'antd-v5';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PhoneInput from 'react-phone-number-input';
import { connect } from 'react-redux';
import Layout from '../../../Layout/StandardLayout';
import PopConfirm from '../../../Layout/PopConfirm';
import KioskSlider from '../../../Layout/KioskSlider';
import { saveListItem, getRequest, deleteRequest, queryMaker } from '../../../../core/apiRequests';
import { notificationSuccess, notificationError } from '../../../../core/actions';
import { AssociateHours } from './associate-hours';

import {
  setAssocAddEdit,
  setFirstName,
  setLastName,
  setMobileNum,
  setEmailAddress,
  setAllowManagerFeatures,
  setAssociateId,
  setAssociateStoreId,
  setDeletedAssociateList,
  setAssociateObject,
  setPOS,
  setAssociateRole,
  setSchedulingLink,
} from '../../../../reducers/associate';
import { setAuthSchedulingLink } from '../../../../reducers/auth';
import ReassignAssociateModal from './ReassignAssociateModal';

const DEFAULT_OUT_OF_OFFICE_RESPONSE =
  "Hi :client_name:, it's :associate: from :merchant_name:. I'm not available right now to assist you. I'll get back to you as soon as I can.";

const AddAssociate = props => {
  const history = useHistory();
  const [showPopConfirm, setShowPopConfirm] = useState(false);
  const [sendInvitation, setSendInvitation] = useState(true);
  const [showPinModal, setShowPinModal] = useState(false);
  const [userPin, setUserPin] = useState('');
  const [localNumber, setLocalNumber] = useState();
  const [showReassignAssoc, toggleReassignAssoc] = useState(false);
  const [tempRole, setTempRole] = useState(null);
  const [selectedStores, setSelectedStores] = useState([]);
  const [roleOptions, setRoleOptions] = useState([{ label: 'Associate', value: 'ASSOCIATE' }]);
  const [storeOptions, setStoreOptions] = useState(props.stores.map(st => ({ label: st.name, value: st.id })));
  const [showPopEmail, setShowPopEmail] = useState(false);
  const [noEmail, setNoEmail] = useState(false);
  const [smsStoreNum, setSmsStoreNum] = useState([]);
  const [qrCodeUrl, setQrCodeUrl] = useState('');
  const [qrModal, setQrModal] = useState(false);
  const [outOfOffice, setOutOfOffice] = useState();
  const [outOfOfficeResponse, setOutOfOfficeResponse] = useState();

  useEffect(() => {
    if ((props.iso_country_code !== 'US' || !localNumber) && !props.associate.emailAddress) {
      setSendInvitation(false);
    } else {
      setSendInvitation(true);
    }
  }, [localNumber, props.associate.emailAddress]);
  /*
  const handleQRCodeClick = useCallback(storeUuid => {
    const url = `${process.env.REACT_APP_OPT_IN_FORM_URL}${queryMaker({
      merchantUuid: props.uuid,
      type: 'appointment',
      storeUuid,
      associateUuid: props.associate.uuid,
    })}`;
    setQrCodeUrl(url);
    setQrModal(true);
  }, []);

  const handleLinkClick = useCallback(storeUuid => {
    console.log('🚀 ~ AddAssociate ~ props.associate:', props.associate);
    const url = `${process.env.REACT_APP_OPT_IN_FORM_URL}${queryMaker({
      merchantUuid: props.uuid,
      type: 'appointment',
      storeUuid,
      associateUuid: props.associate.uuid,
    })}`;
    navigator.clipboard.writeText(url);
    message.success('Link Copied to Clipboard');
  }, []); */

  useEffect(() => {
    if (props.merchantId && props.stores.length > 1) {
      if (window.location.href.includes('add-associate')) {
        setAssocAddEdit('Add');
        setAllowManagerFeatures(false);
        setSmsStoreNum(props.stores.map(st => st.sms_number).filter(store => store !== undefined));
        if (!props.associate.associateStoreId) {
          const validStores = props.stores.filter(st => st.id);
          if (validStores.length > 0) {
            setAssociateStoreId(validStores[0].id);
          }
        }
      } else if (props.match.params.associateId !== props.associate.associateId) {
        const reqObj = {
          params: ['associates', 'details', props.merchantId, props.match.params.associateId],
        };
        (async () => {
          const data = await getRequest(reqObj);
          if (data && data.length > 0) {
            const {
              first_name,
              last_name,
              mobile,
              id,
              email,
              // sendInvit,
              manager,
              location,
              image,
              pin,
              store_id,
              daily_contact_goal,
              count,
              pos_ref_num,
              role,
              stores,
              scheduling_link,
              out_of_office_msg,
              out_of_office_msg_enabled,
              uuid,
            } = data[0];
            setAssociateObject({
              firstName: first_name,
              lastName: last_name,
              mobileNum: mobile,
              emailAddress: email,
              associateId: id,
              allowManagerFeatures: Number(manager) === 1,
              addOrEdit: 'Edit',
              associateStoreId: store_id,
              associateImage: image,
              associatePin: pin,
              associateContactGoal: daily_contact_goal,
              associateAssignedCount: count,
              associateStore: location,
              associatePOS: pos_ref_num,
              role,
              schedulingLink: scheduling_link,
              uuid,
            });
            setTempRole(role);
            if (role === 'ADMIN') {
              setSelectedStores(storeOptions.map(st => st.value));
            } else {
              setStoreOptions(storeOptions.filter(st => st.value !== 0));
              setSelectedStores(stores.map(st => st.store_id));
            }
            if (props.role === 'ADMIN') {
              setRoleOptions([
                { label: 'Admin', value: 'ADMIN' },
                { label: 'Manager', value: 'MANAGER' },
                { label: 'Associate', value: 'ASSOCIATE' },
              ]);
            }
            setAssociateRole(role);
            setLocalNumber(mobile);
            setOutOfOffice(!!out_of_office_msg_enabled);
            setOutOfOfficeResponse(out_of_office_msg);
            setSmsStoreNum(props.stores.map(st => st.sms_number).filter(store => store !== undefined));
          } else {
            history.push('/Associates');
          }
        })();
      }
    }
  }, [props.stores, props.merchantId, props.match.params.associateId]);

  const addEditAssociate = () => {
    const {
      associate: { associateId, firstName, lastName, emailAddress, associatePOS, schedulingLink },
      brandName,
    } = props;
    if (!firstName) {
      notificationError('Associate first name required');
    } else if (!tempRole) {
      notificationError('Role required!');
    } else if (selectedStores.length === 0) {
      notificationError('Store Access required');
    } else if (window.location.href.includes('add-associate') && !emailAddress && !noEmail) {
      setShowPopEmail(true);
    } else if (
      (window.location.href.includes('edit-associate') || userPin || sendInvitation) &&
      selectedStores.length > 0
    ) {
      const phoneNumber = localNumber;
      (async () => {
        const dataObj = {
          firstName,
          lastName,
          mobileNum: phoneNumber,
          emailAddress,
          userPin,
          sendInvite: sendInvitation,
          merchantName: brandName,
          creatorAsct: props.firstName,
          associatePOS,
          role: tempRole,
          conditionedStores: selectedStores.filter(stId => stId),
          schedulingLink,
          outOfOfficeEnabled: outOfOffice,
          outOfOfficeResponse: outOfOfficeResponse ?? DEFAULT_OUT_OF_OFFICE_RESPONSE,
        };
        if (associateId) {
          dataObj.id = associateId;
        }
        if (mobileValidation(phoneNumber) && smsMobile(phoneNumber)) {
          const data = await saveListItem('associates', props.merchantId, dataObj);
          if (data.id) {
            setAssociateId(data.id);
            setAssocAddEdit('Edit');
            setAuthSchedulingLink(schedulingLink);
            // eslint-disable-next-line no-unused-expressions
            props.associate.addOrEdit === 'Edit'
              ? notificationSuccess('Associate Updated')
              : notificationSuccess('Associate Created');
            history.push('/Associates');
          } else {
            setShowPopConfirm(false);
            notificationError('Error Saving Associate');
          }
        }
      })();
    } else if (window.location.href.includes('add-associate') && !sendInvitation) {
      setShowPinModal(true);
    } else {
      notificationError('Please assign store access');
    }
  };

  const mobileValidation = phone => {
    if (!phone) {
      return true;
    }
    if (phone.match(/\d/g).length >= 10) {
      return true;
    }
    notificationError('Enter valid mobile phone number!');
    return false;
  };

  const smsMobile = phone => {
    if (!phone) {
      return true;
    }
    if (phone !== undefined) {
      if (phone.match(/\d/g).length >= 10) {
        const smsCompare = smsStoreNum.filter(number => {
          if (number.replace(/[^0-9]+/g, '') === phone.replace(/[^0-9]+/g, '')) {
            return true;
          }
          return false;
        });
        if (smsCompare.length > 0) {
          notificationError('Associate phone number cannot match store number!');
        } else return true;
      }
    }
  };

  const confirmDelete = newAssociateId => {
    (async () => {
      const reqObj = {
        params: ['associates', props.merchantId, 'remove', props.associate.associateId],
        query: {
          deletedBy: props.userId,
          newAssociateId,
        },
      };
      const data = await deleteRequest(reqObj);
      if (data) {
        notificationSuccess('Associate Removed');
        setShowPopConfirm(false);
        setDeletedAssociateList(props.associate.associateId);
        history.push('/Associates');
        toggleReassignAssoc(false);
      } else {
        // notificationError('Error Deleting Associate');
        setShowPopConfirm(false);
        toggleReassignAssoc(false);
      }
    })();
  };
  const handleOutOfOfficeChange = checked => {
    setOutOfOffice(checked);
    if (checked) {
      if (!outOfOfficeResponse) {
        setOutOfOfficeResponse(DEFAULT_OUT_OF_OFFICE_RESPONSE);
      }
    }
  };

  const redirectBack = () => {
    if (props.match.params.associateId) {
      history.push(`/Associates/associate-details/${props.match.params.associateId}`);
    } else {
      history.push('/Associates');
    }
  };

  return (
    <Layout
      title={`${window.location.href.includes('add-associate') ? 'Add' : 'Edit'} Associates`}
      description={
        window.location.href.includes('add-associate')
          ? 'Create a sales associate app account'
          : `Edit ${props.associate.firstName}'s information`
      }
      breadCrumbs={[
        { title: 'Associates', to: '/Associates' },
        {
          title: `${window.location.href.includes('add-associate') ? 'Add' : 'Edit'} Associate`,
        },
      ]}
      classProps="standard-width-wo-sidebar"
      actions={
        <>
          <Button type="primary" id="AssociateSaveButton" onClick={addEditAssociate}>
            Save
          </Button>
          <Button type="default" id="AssociateCancelButton" onClick={() => redirectBack()}>
            Cancel
          </Button>
          <Button id="DeleteAssociate" type="primary" danger onClick={() => toggleReassignAssoc(true)}>
            Delete Associate
          </Button>
        </>
      }
    >
      <div className="addAsctInputRows w-100-P">
        <Typography.Title level={5} className="m-btm-15">
          <FontAwesomeIcon className="p-right-6" icon={['far', 'circle-user']} /> Associate Details
        </Typography.Title>
        <Input
          id="AssociateFirstName"
          placeholder="First Name"
          className="addAssociateInputs"
          prefix={<FontAwesomeIcon className="p-right-6 gray" icon={['far', 'user']} />}
          value={props.associate.firstName || ''}
          onChange={e => setFirstName(e.target.value)}
        />
        <Input
          id="AssociateLastName"
          className="addAssociateInputs"
          placeholder="Last Name"
          prefix={<FontAwesomeIcon className="p-right-6 gray" icon={['far', 'user']} />}
          value={props.associate.lastName || ''}
          onChange={e => setLastName(e.target.value)}
        />
        <PhoneInput
          id="AssociatePhoneNumber"
          placeholder="Enter phone number"
          value={localNumber}
          onChange={e => {
            setLocalNumber(e);
            smsMobile(e);
          }}
          defaultCountry={props.iso_country_code}
          className="addAssociateInputs"
        />
        <Input
          id="AssociateEmail"
          placeholder="Email Address"
          value={props.associate.emailAddress || ''}
          className="addAssociateInputs"
          prefix={<FontAwesomeIcon className="p-right-6 gray" icon={['far', 'envelope']} />}
          onChange={e => {
            setEmailAddress(e.target.value);
          }}
        />
        {props.pos_type && (
          <Input
            placeholder="Point of Sale ID"
            value={props.associate.associatePOS || ''}
            prefix={<FontAwesomeIcon className="p-right-6 gray" icon={['fal', 'address-card']} />}
            className="addAssociateInputs"
            onChange={e => {
              setPOS(e.target.value);
            }}
            maxLength="50"
          />
        )}
        <Typography.Title level={5} className="m-btm-15  m-top-30">
          <FontAwesomeIcon className="p-right-6" icon={['far', 'lock']} /> Permissions
        </Typography.Title>
        {/* role */}
        <Select
          options={roleOptions}
          placeholder="Role"
          value={tempRole}
          className="addAssociateInputs"
          disabled={props.role !== 'ADMIN'}
          onChange={value => {
            setTempRole(value);
            if (value === 'ADMIN') {
              setStoreOptions(props.stores.map(st => ({ label: st.name, value: st.id })));
              setSelectedStores(props.stores.map(st => st.id));
            } else {
              setSelectedStores([]);
              setStoreOptions(storeOptions.filter(st => st.value !== 0));
            }
          }}
        />
        <Select
          options={storeOptions}
          placeholder="Stores Access"
          mode={tempRole !== 'ADMIN' ? 'multiple' : 'default'}
          value={selectedStores}
          style={{ height: 'auto' }}
          className="addAssociateInputs"
          disabled={tempRole === 'ADMIN'}
          onChange={value => {
            console.log('🚀 ~ value:', value);
            setSelectedStores(value);
          }}
        />
        {/* pos div */}
        <Typography.Title level={5} className="m-btm-15  m-top-30">
          <FontAwesomeIcon className="p-right-6" icon={['far', 'lock']} /> Appointment Links
        </Typography.Title>
        <Typography.Text className="m-btm-15 gray">View your appointment links and enter a custom link</Typography.Text>
        <div style={{ display: 'grid', justifyItems: 'start', gridTemplateColumns: '1fr 4fr' }}>
          {/* {selectedStores
            ?.filter(stId => stId)
            .map(stId => {
              const stObj = props.stores.find(st => st.id === stId);
              if (stObj) {
                return (
                  <>
                    <Typography.Text key={stId} level={5} className="m-btm-8 fs-16">
                      {stObj.name} Appointment Link
                    </Typography.Text>
                    <div>
                      <FontAwesomeIcon
                        className="p-left-15 pointer blue"
                        size="lg"
                        onClick={() => handleQRCodeClick(stObj.uuid)}
                        icon={['far', 'qrcode']}
                      />
                      <FontAwesomeIcon
                        className="p-left-10 pointer blue"
                        size="lg"
                        onClick={() => handleLinkClick(stObj.uuid)}
                        icon={['far', 'link']}
                      />
                    </div>
                  </>
                );
              }
              return null;
            })} */}
          {props?.merchantFlags?.scheduling_link?.enabled && (
            <>
              <Input
                className="addAssociateInputs"
                placeholder="Scheduling link"
                value={props.associate.schedulingLink || ''}
                prefix={<FontAwesomeIcon className="p-right-6 gray" icon={['fal', 'calendar']} />}
                onChange={e => {
                  setSchedulingLink(e.target.value);
                }}
              />
              <div>
                <FontAwesomeIcon
                  className="p-left-15 pointer blue"
                  size="lg"
                  onClick={() => {
                    setQrCodeUrl(props.associate.schedulingLink);
                    setQrModal(true);
                  }}
                  icon={['far', 'qrcode']}
                />
                <FontAwesomeIcon
                  className="p-left-10 pointer blue"
                  size="lg"
                  onClick={() => {
                    navigator.clipboard.writeText(props.associate.schedulingLink);
                    message.success('Link Copied to Clipboard');
                  }}
                  icon={['far', 'link']}
                />
              </div>
            </>
          )}
        </div>
        <Typography.Title level={5} className="m-btm-15  m-top-30">
          <FontAwesomeIcon className="p-right-6" icon={['far', 'lock']} /> Work Schedule
        </Typography.Title>
        <Typography.Text className="m-btm-15 gray">
          Manage your regular work schedule. This will be used when scheduling appointments and for out of office
          response.
        </Typography.Text>
        <AssociateHours
          associateId={props.match.params.associateId}
          storeOptions={storeOptions.filter(item => item.value)}
        />
        <div className="m-top-30 w-100-P flex-row-spacebetween-center">
          <div>
            <Typography.Title style={{ textAlign: 'left' }} level={5} className="m-btm-15">
              Out of Office response
            </Typography.Title>
            <Typography.Paragraph style={{ textAlign: 'left' }} className="m-btm-15 gray">
              Send a response to any inbound message from an assigned client, regardless of store. If you are working in
              any location, the message will not go out.
            </Typography.Paragraph>
          </div>
          <Switch checked={outOfOffice} onChange={handleOutOfOfficeChange} />
        </div>
        <Input.TextArea
          disabled={!outOfOffice}
          rows={4}
          placeholder="Out of Office response"
          value={outOfOfficeResponse}
          onChange={e => setOutOfOfficeResponse(e.target.value)}
        />
      </div>
      <Modal
        open={qrModal}
        okButtonProps={{ style: { display: 'none' } }}
        onCancel={() => setQrModal(false)}
        onClose={() => setQrModal(false)}
      >
        <QRCode style={{ justifySelf: 'center' }} value={qrCodeUrl} />
      </Modal>

      {showPinModal ? (
        <ChangePinModal
          closeModal={() => setShowPinModal(false)}
          setUserPin={setUserPin}
          userPin={userPin}
          addEditAssociate={addEditAssociate}
        />
      ) : null}
      {showReassignAssoc ? (
        <ReassignAssociateModal
          toggleReassignAssoc={toggleReassignAssoc}
          storeObjs={props.stores}
          merchantId={props.merchantId}
          associate={props.associate}
          confirmDelete={confirmDelete}
        />
      ) : null}
      {showPopEmail ? (
        <PopConfirm
          confirm="Proceed without an email address?"
          description="Associate will not be able to access the dashboard and will not receive login instructions in their inbox"
          onCancel={() => setShowPopEmail(false)}
          onConfirm={() => {
            setShowPopEmail(false);
            setNoEmail(true);
          }}
        />
      ) : null}
    </Layout>
  );
};

const mapStateToProps = state => ({
  associate: state.associate,
  ...state.auth,
  ...state.notification,
});

const mapDispatchToProps = dispatch => ({
  setAssocAddEdit(val) {
    dispatch({
      type: 'SET_ASCT_ADD_EDIT',
      payload: val,
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AddAssociate);

const ChangePinModal = props => {
  const backgroundCloseHandler = e => {
    if (e.target.id === 'modal-background') {
      props.closeModal();
    }
  };

  return (
    <div className="pop-confirm-background" id="modal-background" onClick={backgroundCloseHandler}>
      <div className="pop-confirm-container rem-pad-width" style={{ width: '388px', height: '294px' }}>
        <div className="flex-col-center h-100-P" style={{ justifyContent: 'flex-start' }}>
          <div className="flex-row-spacebetween-nowrap w-100-P m-top-15">
            <div />
            <FontAwesomeIcon
              onClick={props.closeModal}
              className="light-gray m-right-15 pointer"
              size="2x"
              icon={['far', 'times']}
            />
          </div>
          <span className="fs-20 fw-500" style={{ marginTop: '0px' }}>
            Please Enter A Pin
          </span>
          <input
            placeholder="4321"
            className="h-50 w-160 align-center m-top-37"
            value={props.userPin}
            onChange={e => props.setUserPin(e.target.value)}
          />
          <Button
            type="primary"
            size="large"
            onClick={props.addEditAssociate}
            className="m-top-37"
            style={{ width: '160px' }}
            disabled={!props.userPin}
          >
            Save
          </Button>
          {/* </div> */}
        </div>
      </div>
    </div>
  );
};
